import angular from "angular";

const alarmUtilsService = () => ({
    uniqueAlarmNames: (alarms, property) => {
        if (!alarms) {
            return [];
        }
        property = property || 'alarmName';
        return [...new Set(alarms.map(a => (a[property] || '').split(':')[0]))]
            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }
});

angular.module('ui-common').factory('AlarmUtilsService', alarmUtilsService);
